import React from 'react'

import { TherapistStatus, type TherapistType } from '../types/TherapistStateType'
import Bubble from './Bubble'

type Props = { therapists: TherapistType[]; sizeClass?: string }

const DISPLAYED_THERAPISTS = 3

const TherapistBubbles: React.FC<Props> = ({ therapists, sizeClass }) => {
  const filteredTherapists = therapists.filter((therapist) => therapist.status !== TherapistStatus.TESTING)

  return (
    <div className="flex p-3">
      {Array.from(Array(DISPLAYED_THERAPISTS).keys()).map((index) => {
        const therapist = filteredTherapists?.[index]
        return (
          <Bubble
            sizeClass={sizeClass}
            imgUrl={therapist?.image || '/images/svg/misc/therapist-placeholder.svg'}
            key={index}
            className={therapist ? '' : 'invisible'}
          />
        )
      })}
    </div>
  )
}

export default TherapistBubbles
